import { LotteryConfigModel } from "../models/lottery-configuration-model";
import { Lottery } from "../../../models/lottery";

export const extraRentaConfig: LotteryConfigModel = {
    lottery: Lottery.extraRenta,
    boardCount: 4,
    primaryBoardSize: 7,
    defaultStake: 25,
    defaultStakeKasa: 2500,
    primaryNumbers: 33,
    boardLabel: "Sloupec",

    hasDurationComponent: true,
    hasDrawOptions: true,
    hasMultidrawNotification: true,
    hasAllOrOneMultidrawOptions: true,
    hasSubscription: true,
    isDrawnEveryDay: true,
    durationTitle: "Extra renta se hraje pravidelně 2&#215; týdně",
    durationTitleShort: "Extra renta se hraje pravidelně 2x týdně.",
    maxDuration: 24,
    stakeOptions: [25, 50],

    multidrawDurationOptions: [
        { value: "mon", valueKasa: "MONDAY", mainText: "Pondělí", dayOfWeek: 1, hour: 20, drawName: "mon" },
        { value: "thu", valueKasa: "THURSDAY", mainText: "Čtvrtek", dayOfWeek: 4, hour: 20, drawName: "thu" },
    ],
};
